function getSearch() {
  var url = location.search.toLowerCase(),
    searchResult = {},
    str = '',
    strs = [],
    i = 0;
  if (url.indexOf('?') >= 0) {
    str = url.substr(1);
    strs = str.split('&');
    for (; i < strs.length; i++) {
      searchResult[strs[i].split('=')[0]] = unescape(strs[i].split('=')[1]);
    }
  }
  return searchResult;
}
const URLSearchCodes = getSearch();
export default URLSearchCodes;
export {getSearch};



// WEBPACK FOOTER //
// ./src/utils/getSearch.js